(function(angular, module) {var pickerTagListController, pickerTagListDirective;

pickerTagListController = function($element) {
  'ngInject';
  this.tagPicker = $element.controller('dybTagPicker');
};

pickerTagListDirective = function() {
  'ngInject';
  return {
    restrict: 'E',
    templateUrl: 'util/tags/pickerTagList',
    scope: {
      tagGroup: '='
    },
    require: '^dybTagPicker',
    controller: pickerTagListController,
    bindToController: true,
    controllerAs: 'ctrl'
  };
};

module.directive('dybTagpickerTagList', pickerTagListDirective);
})(angular, angular.module("dybTags"));